module.exports = __webpack_public_path__ + "static/media/repeat_grid_3.339ddb2d.svg";